<template>
    <layout>
    	<div class="row">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    @error-load="showError"
                    tableClass="table-responsive-sm table-auto"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle">
                                    </header-list>
                                </div>
                            </div>
                        </form>
                    </template>
                    <template v-slot:body="{row, index, resetSearch}">
                        <td :class="table.columns[0].class">
                            {{ columnValue(row, table.columns[0]) }}
                        </td>
                        <td :class="[table.columns[1].class, {'tbl-column-disabled': !row.status}]">
                            {{ columnValue(row, table.columns[1]) }}
                        </td>
                        <td :class="table.columns[2].class" v-html="columnOnOff(row, table.columns[2])"></td>
                        <td :class="table.columns[3].class" v-html="columnStatus(row, table.columns[3], ['', 'fas fa-lock'], css=['', 'text-info'])"></td>
                        <td :class="table.columns[4].class" v-html="columnStatus(row, table.columns[4])"></td>
                        <column-actions v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="onBeforeDeleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete && !!!row.persistent"
                            :row="row"
                            :index="index"
                            :callbackDelete="resetSearch" />
                    </template>
                </table-data>

			</div>

    	</div>
    </layout>
</template>

<script>
	import GeneralMixin from '../../mixin'

    export default {
        mixins: [
            GeneralMixin
        ],
    	data() {
            let pageID = 'modules';
      		return {
                pageID: pageID,
                table: {
                    settings: {
                        order_by: 'name',
                        sort: 'asc',
                    },
                    columns: [
                        {
                            label: `${pageID}.list.order`,
                            field: 'order',
                            class: 'order',
                            sortable: true,
                        },
                        {
                            label: `${pageID}.list.name`,
                            field: 'name',
                            sortable: true,
                        },
                        {
                            label: `${pageID}.list.backoffice`,
                            field: 'backoffice',
                            sortable: true,
                            class: "text-center",
                        },
                        {
                            label: `${pageID}.list.guest`,
                            field: 'guest',
                            sortable: true,
                            class: "text-center",
                        },
                        {
                            label: `${pageID}.list.status`,
                            field: 'status',
                            sortable: true,
                            class: "text-center",
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
      		}
    	},
    	methods: {
            onBeforeDeleteItem: function(id, index, callback) {
                if(this.canDelete) {
                    this.deleteItem(id, index, callback).then(res => {
                        let success = res == true || [200, 201].includes(res?.status);
                        if(success && this.$auth) {
                            this.$auth.fetch();
                        }
                    })
                }
            },
    	}
  	}
</script>
